import HorizontalContainerWithFadedOverflow from 'components/Common/HorizontalContainerWithFadedOverflow'
import { rem } from 'polished'
import React, { forwardRef, PropsWithChildren } from 'react'
import styled from 'styled-components'

const Container = styled(HorizontalContainerWithFadedOverflow)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${rem(4)};
`

interface Props extends PropsWithChildren {
}

const _StepsTrack = forwardRef<HTMLDivElement, Props>(function _StepsTrack(props, ref) {
  return <Container {...props} ref={ref} />
})

export default _StepsTrack
